import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Link } from "capitalrx-components-2.0/lib/general";
import Skeleton from "react-loading-skeleton";

import { Tag } from "@/basic/components";
import { getAppleMapsURL } from "@/basic/components/AppleMap";

interface DetailsPageHeaderProps {
  isLoading: boolean;
  address: string;
  tags?: Array<string>;
}

export const DetailsPageHeader = (props: DetailsPageHeaderProps) => {
  const { address, tags, isLoading } = props;

  return (
    <Stack spacing="mini">
      <>
        {tags
          && tags.map((tagName: string) => {
            <Tag key={tagName}>{tagName}</Tag>;
          })}

        {isLoading ? (
          <Skeleton />
        ) : (
          <Link
            to={{
              pathname: getAppleMapsURL({ data: { address } }),
            }}
          >
            {address}
          </Link>
        )}
      </>
    </Stack>
  );
};
